module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image02-1440x700@2x.3f192b71.jpg";